import React from "react";
import { PageHeader, DisclaimerFooter } from "@/components/Bits";
import { useChallenge } from "@/context/ChallengeContext";
import { fmtUSD } from "@/lib/calc";
import { Trophy, Lock } from "lucide-react";
import { motion } from "framer-motion";

export default function Milestones() {
  const { data } = useChallenge();
  const milestones = data?.config?.milestones || [500, 1000, 2500, 5000, 10000, 25000, 50000, 100000, 200000];
  const unlocked = data?.unlocked_milestones || [];
  const balance = data?.current_balance ?? 350;

  return (
    <div>
      <PageHeader title="Milestones" subtitle={`Aktualny kapitał: ${fmtUSD(balance)}`} />
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {milestones.map((m, i) => {
          const isUnlocked = unlocked.includes(m);
          return (
            <motion.div
              key={m}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.05 }}
              data-testid={`milestone-${m}`}
              className={`rounded-2xl p-6 text-center border transition-all ${
                isUnlocked
                  ? "bg-gradient-to-br from-amber-500/20 via-yellow-500/5 to-amber-600/15 border-amber-500/40 shadow-[0_0_20px_rgba(245,158,11,0.25)]"
                  : "glow-card opacity-60"
              }`}
            >
              {isUnlocked ? (
                <Trophy className="text-amber-400 mx-auto mb-2 gold-glow" size={28} />
              ) : (
                <Lock className="text-demon-muted mx-auto mb-2" size={24} />
              )}
              <div className={`font-mono text-xl font-bold ${isUnlocked ? "text-amber-300 gold-glow" : "text-white"}`}>
                {fmtUSD(m, 0)}
              </div>
              <div className="text-[10px] tracking-widest mt-2 text-demon-muted">
                {isUnlocked ? "UNLOCKED" : "LOCKED"}
              </div>
            </motion.div>
          );
        })}
      </div>
      <DisclaimerFooter />
    </div>
  );
}
